main.slider = (function () {
    var slider;
    var sliderControls;
    var sliderNode;

    var init = function () {
        var sliderSelector = '.js-slider';
        sliderNode = document.querySelector(sliderSelector);

        if (!sliderNode) { return; }

        sliderControls = document.getElementsByClassName('c-slider__controls')[0];
        slider = tns({
            container: '.js-slider',
            controlsContainer: sliderControls,
            fixedWidth: 280,
            gutter: 25,
            loop: false,
            mouseDrag: true,
            nav: false,
            slideBy: 'page',
            responsive: {
                768: {
                    fixedWidth: 360,
                }
            }
        });
    };

    var checkStatus = function () {
        if (!sliderNode) { return; }

        if (sliderControls.style.display === 'none') {
            sliderNode.classList.remove('is-active');
        } else {
            sliderNode.classList.add('is-active');
        }
    };

    return {
        init: init,
        checkStatus: checkStatus
    };
})();
